import { createSelector } from "reselect";

const productSuggestionsState = (state) => state.store.productSuggestions;

export const getSuggestionsSelector = createSelector(
  productSuggestionsState,
  (data) => (data ? data.items : [])
);

export const getIngredientOptionsSelector = createSelector(
  productSuggestionsState,
  (data) =>
    data && data.ingredients
      ? data.ingredients.map((i) => ({ value: i.id, label: i.name, isSauce: i.isSauce }))
      : []
);
